<div class="tenant-form">
	<ng-container *ngIf="!successMessage && !editedSuccess;else sentMessageResult;">
		<form [formGroup]="tenantForm" (ngSubmit)="onSubmit()">
			<mat-card class="mat-elevation-z">
				<div class="flex flex-row justify-between items-center">
					<mat-card-content class="fs-24 fw-700 mb-6">{{title }}</mat-card-content>
					<mat-icon class="justify-items-end cursor-pointer icon-lg mr-16" (click)="closeSidenav()"  svgIcon="close"></mat-icon>
				</div>
				<mat-divider class="mt-10 neutral-2"></mat-divider>
				<div class="flex flex-row justify-between">
					<mat-card-content>
						<div class="flex flex-col form-group mat-subtitle-2 mt-16">
							<div class="flex flex-row">
								<label class="fw-700 fs-12" for="username">{{tenantName | uppercase}}</label>
								<mat-icon svgIcon="info" class="icon-sm ml-4 mt-4" matTooltipClass="form-tooltip right" [matTooltip]="'TENANT_FORM.ENTER_FOUNDATION_REALM_NAME' | transloco"
									matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
							</div>
							<input type="text" [ngClass]="{'disabled': edit}" placeholder="{{'TENANT_FORM.FOUNDATION_REALM_NAME' | transloco}}"
								formControlName="tenantId" class="fw-500" required >
								<app-error [control]="tenantForm.get('tenantId')"></app-error>
						</div>
					</mat-card-content>
					<mat-card-content>
						<div class="flex flex-col form-group mat-subtitle-2">
							<div class="flex flex-row pt-16">
								<label class="fw-700 fs-12">{{'TENANT_FORM.TEMENOS_CLOUD' | transloco | uppercase}}</label>
								<mat-icon svgIcon="info" class="icon-sm ml-4 mt-4" matTooltipClass="form-tooltip right" [matTooltip]="'TENANT_FORM.SELECT_CLOUD' | transloco"
								matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
							</div>
							<mat-select [formControl]="tenantForm.get('cloudProvider')" [ngClass]="{'disabled': edit}" class="fw-500 form-select" [placeholder]="'TENANT_FORM.CHOOSE_CLOUD' | transloco" required>
								<mat-option *ngFor="let cloud of cloud" [value]="cloud">{{ cloud | titlecase }}</mat-option>
							</mat-select>
							<app-error [control]="tenantForm.get('cloudProvider')"></app-error>
						</div>
					</mat-card-content>
				</div>
				<div class="flex flex-row justify-between">
					<mat-card-content>
						<div class="flex flex-col form-group mat-subtitle-2 mb-16">
							<div class="flex flex-row">
								<label class="fw-700 fs-12">{{'TENANT_FORM.CHOOSE_REGION' | transloco | uppercase}}</label>
							</div>
							<div class="flex flex-row">
								<mat-button-toggle-group class="flex flex-row toggle-button w-100-percent" value="temenos" (change)="onValChange($event.value)" #direction="matButtonToggleGroup">
									<mat-button-toggle value="temenos" [ngClass]="{'selected-toggle': !toggleEnabledData}">
										{{'ADD_VERSION.TEMENOS_REGION' | transloco | titlecase}}
									</mat-button-toggle>
									<mat-button-toggle disabled value="cloud" [ngClass]="{'selected-toggle': toggleEnabledData}">
										{{'ADD_VERSION.CLOUD_REGION' | transloco | titlecase}}
									</mat-button-toggle>
								</mat-button-toggle-group>
							</div>
						</div>
					</mat-card-content>
					<mat-card-content *ngIf="toggleEnabledData" class="pb-0">
						<div class="flex flex-col form-group mat-subtitle-2 w-100-percent mb-16">
							<div class="flex flex-row">
								<label class="fw-700 fs-12">{{'TENANT_FORM.TEMENOS_REGION' | transloco | uppercase}}</label>
								<mat-icon [satPopoverAnchor]="regionPair" (click)="regionPair.toggle()" svgIcon="info" class="icon-sm ml-4 mt-4"></mat-icon>
							</div>
							<mat-select [ngClass]="{'disabled': edit}" [formControl]="tenantForm.get('regionPair')" class="fw-500 form-select" [placeholder]="'TENANT_FORM.CHOOSE_REGION' | transloco">
								<mat-option *ngFor="let region of regions" [value]="region">{{ region }}</mat-option>
							</mat-select>
							<app-error [control]="tenantForm.get('regionPair')"></app-error>
						</div>
					</mat-card-content>
					<mat-card-content *ngIf="!toggleEnabledData">
						<div class="flex flex-col form-group mat-subtitle-2">
							<div class="flex flex-row">
								<label class="fw-700 fs-12" for="username">{{'TENANT_LIST.PRIMARY_REGION' | transloco | uppercase}}</label>
								<mat-icon svgIcon="info" [satPopoverAnchor]="primaryCloudRegion" (click)="primaryCloudRegion.toggle()" class="icon-sm ml-4 mt-4"></mat-icon>
							</div>
							<input [ngClass]="{'disabled': edit}" type="text" placeholder="{{'TENANT_LIST.PRIMARY_REGION' | transloco}}"
								formControlName="primaryCloudRegion" class="fw-500" required >
								<app-error [control]="tenantForm.get('primaryCloudRegion')"></app-error>
						</div>
					</mat-card-content>
					<mat-card-content *ngIf="!toggleEnabledData">
						<div class="flex flex-col form-group mat-subtitle-2">
							<div class="flex flex-row">
								<label class="fw-700 fs-12" for="username">{{'TENANT_LIST.SECONDARY_REGION' | transloco | uppercase}}</label>
								<mat-icon svgIcon="info" [satPopoverAnchor]="secondaryCloudRegion" (click)="secondaryCloudRegion.toggle()" class="icon-sm ml-4 mt-4"></mat-icon>
							</div>
							<input [ngClass]="{'disabled': edit}" type="text" placeholder="{{'TENANT_LIST.SECONDARY_REGION' | transloco}}"
								formControlName="secondaryCloudRegion" class="fw-500" required >
								<app-error [control]="tenantForm.get('secondaryCloudRegion')"></app-error>
						</div>
					</mat-card-content>
				</div>
				<mat-divider class="mb-16 mt-8 neutral-2 mat-divider-dashed"></mat-divider>
				<div class="flex flex-row justify-between">
					<mat-card-content>
						<div class="flex flex-col form-group mat-subtitle-2">
							<div class="flex flex-row">
								<label class="fw-700 fs-12" for="username">{{'TENANT_FORM.CUSTOMER_NAME' | transloco | uppercase}}</label>
								<mat-icon svgIcon="info" class="icon-sm ml-4 mt-4" matTooltipClass="form-tooltip right" [matTooltip]="'TENANT_FORM.ENTER_CUSTOMER_NAME' | transloco"
									matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
							</div>
							<input type="text" placeholder="{{'TENANT_FORM.ENTER_CUSTOMER_NAME' | transloco}}"
								formControlName="customerName" class="fw-500">
						</div>
					</mat-card-content>
					<mat-card-content>
						<div class="flex flex-col form-group mat-subtitle-2">
							<div class="flex flex-row">
								<label class="fw-700 fs-12" for="username">{{'TENANT_FORM.CUSTOMER_NUMBER' | transloco | uppercase}}</label>
								<mat-icon svgIcon="info" class="icon-sm ml-4 mt-4" matTooltipClass="form-tooltip right" [matTooltip]="'TENANT_FORM.ENTER_CUSTOMER_NUMBER' | transloco"
									matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
							</div>
							<input type="text" placeholder="{{'TENANT_FORM.ENTER_CUSTOMER_NUMBER' | transloco}}"
								formControlName="customerNumber" class="fw-500" required >
								<app-error [control]="tenantForm.get('customerNumber')"></app-error>
						</div>
					</mat-card-content>
				</div>
				<div class="flex flex-row justify-between">
					<mat-card-content>
						<div class="flex flex-col form-group mat-subtitle-2">
							<div class="flex flex-row">
								<label class="fw-700 fs-12" for="username">{{'TENANT_FORM.CUSTOMER_REGION' | transloco | uppercase}}</label>
								<mat-icon svgIcon="info" class="icon-sm ml-4 mt-4" matTooltipClass="form-tooltip right" [matTooltip]="'TENANT_FORM.ENTER_CUSTOMER_REGION' | transloco"
									matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
							</div>
							<input type="text" placeholder="{{'TENANT_FORM.ENTER_CUSTOMER_REGION' | transloco}}"
								formControlName="customerRegion" class="fw-500">
						</div>
					</mat-card-content>
					<mat-card-content>
						<div class="flex flex-col form-group mat-subtitle-2">
							<div class="flex flex-row">
								<label class="fw-700 fs-12" for="username">{{'TENANT_FORM.CUSTOMER_COUNTRY' | transloco | uppercase}}</label>
								<mat-icon svgIcon="info" class="icon-sm ml-4 mt-4" matTooltipClass="form-tooltip right" [matTooltip]="'TENANT_FORM.ENTER_CUSTOMER_COUNTRY' | transloco"
									matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
							</div>
							<input type="text" placeholder="{{'TENANT_FORM.ENTER_CUSTOMER_COUNTRY' | transloco}}"
								formControlName="customerCountry" class="fw-500">
								<app-error [control]="tenantForm.get('customerCountry')"></app-error>
						</div>
					</mat-card-content>
				</div>
				<div class="flex flex-row justify-between">
					<mat-card-content>
						<div class="flex flex-col form-group mat-subtitle-2">
							<div class="flex flex-row">
								<label class="fw-700 fs-12" for="username">{{'TENANT_FORM.CUSTOMER_MNEMONIC' | transloco | uppercase}}</label>
								<mat-icon svgIcon="info" class="icon-sm ml-4 mt-4" matTooltipClass="form-tooltip right" [matTooltip]="'TENANT_FORM.ENTER_CUSTOMER_MNEMONIC' | transloco"
									matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
							</div>
							<input type="text" placeholder="{{'TENANT_FORM.ENTER_CUSTOMER_MNEMONIC' | transloco}}"
								formControlName="customerMnemonic" class="fw-500">
						</div>
					</mat-card-content>
					<mat-card-content>
						<div class="flex flex-col form-group mat-subtitle-2">
							<div class="flex flex-row">
								<label class="fw-700 fs-12" for="username">{{'TENANT_FORM.TENANT_OWNER' | transloco | uppercase}}</label>
								<mat-icon svgIcon="info" class="icon-sm ml-4 mt-4" matTooltipClass="form-tooltip right" [matTooltip]="'TENANT_FORM.ENTER_TENANT_OWNER' | transloco"
									matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
							</div>
							<input type="text" placeholder="{{'TENANT_FORM.ENTER_TENANT_OWNER' | transloco}}"
								formControlName="tenantOwner" class="fw-500" required >
								<app-error [control]="tenantForm.get('tenantOwner')"></app-error>
						</div>
					</mat-card-content>
				</div>
				<div class="flex flex-row justify-between">
					<mat-card-content *ngIf="toggleEnabledData" class="pb-0">
						<div class="flex flex-col form-group mat-subtitle-2 w-100-percent mb-16">
							<div class="flex flex-row">
								<label class="fw-700 fs-12">{{'TENANT_FORM.CUSTOMER_SCORECARD' | transloco | uppercase}}</label>
								<mat-icon svgIcon="info" class="icon-sm ml-4 mt-4" matTooltipClass="form-tooltip right" [matTooltip]="'TENANT_FORM.ENTER_CUSTOMER_SCORECARD' | transloco"
									matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
							</div>
							<mat-select [ngClass]="{'disabled': edit && editData.scoreCard}" [formControl]="tenantForm.get('scoreCard')" class="fw-500 form-select" [placeholder]="'TENANT_FORM.CHOOSE_CUSTOMER_SCORECARD' | transloco">
								<mat-option *ngFor="let scorecard of scorecards" [value]="scorecard">{{ scorecard }}</mat-option>
							</mat-select>
							<app-error [control]="tenantForm.get('scoreCard')"></app-error>
						</div>
					</mat-card-content>
					<mat-card-content *ngIf="toggleEnabledData" class="pb-0">
						<div class="flex flex-col form-group mat-subtitle-2 w-100-percent mb-16">
							<div class="flex flex-row">
								<label class="fw-700 fs-12">{{'TENANT_FORM.CUSTOMER_SALESCHANNEL' | transloco | uppercase}}</label>
								<mat-icon svgIcon="info" class="icon-sm ml-4 mt-4" matTooltipClass="form-tooltip right" [matTooltip]="'TENANT_FORM.ENTER_CUSTOMER_SALESCHANNEL' | transloco"
									matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
							</div>
							<mat-select [ngClass]="{'disabled': edit && editData.salesChannel}" [formControl]="tenantForm.get('salesChannel')" class="fw-500 form-select" [placeholder]="'TENANT_FORM.CHOOSE_CUSTOMER_SALESCHANNEL' | transloco">
								<mat-option *ngFor="let saleschannel of saleschannels" [value]="saleschannel">{{ saleschannel }}</mat-option>
							</mat-select>
							<app-error [control]="tenantForm.get('salesChannel')"></app-error>
						</div>
					</mat-card-content>
				</div>
				<div class="flex flex-row justify-between">
					<mat-card-content *ngIf="toggleEnabledData" class="pb-0">
						<div class="flex flex-col form-group mat-subtitle-2 w-100-percent mb-16">
							<div class="flex flex-row">
								<label class="fw-700 fs-12">{{'TENANT_FORM.CUSTOMER_STATUS' | transloco | uppercase}}</label>
								<mat-icon svgIcon="info" class="icon-sm ml-4 mt-4" matTooltipClass="form-tooltip right" [matTooltip]="'TENANT_FORM.ENTER_CUSTOMER_STATUS' | transloco"
									matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
							</div>
							<mat-select [ngClass]="" [formControl]="tenantForm.get('status')" class="fw-500 form-select" [placeholder]="'TENANT_FORM.CHOOSE_CUSTOMER_STATUS' | transloco">
								<mat-option *ngFor="let status of statuses" [value]="status">{{ status | titlecase }}</mat-option>
							</mat-select>
							<app-error [control]="tenantForm.get('status')"></app-error>
						</div>
					</mat-card-content>
					<mat-card-content *ngIf="toggleEnabledData" class="pb-0">
						<div class="flex flex-col form-group mat-subtitle-2 w-100-percent mb-16">
							<div class="flex flex-row">
								<label class="fw-700 fs-12">{{'TENANT_FORM.IT_TICKETNUMBER' | transloco | uppercase}}</label>
								<mat-icon svgIcon="info" class="icon-sm ml-4 mt-4" matTooltipClass="form-tooltip right" [matTooltip]="'TENANT_FORM.ENTER_IT_TICKETNUMBER' | transloco"
									matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
							</div>
							<input type="text" placeholder="{{'TENANT_FORM.ENTER_IT_TICKETNUMBER' | transloco}}"
								formControlName="ticketNumber" class="fw-500" [ngClass]="{'disabled': edit && editData.ticketNumber}">
							<app-error [control]="tenantForm.get('ticketNumber')"></app-error>
						</div>
					</mat-card-content>
				</div>
				<div class="flex flex-row justify-between">
					<mat-card-content *ngIf="toggleEnabledData" class="pb-0">
						<div class="flex flex-col form-group mat-subtitle-2 w-full mb-16 ">
							<div class="flex flex-row ml--14">
								<label class="fw-700 fs-12">{{'TENANT_FORM.CONTRACT_END_DATE' | transloco | uppercase}}</label>
								<mat-icon svgIcon="info" class="icon-sm ml-4 mt-4" matTooltipClass="form-tooltip right" [matTooltip]="'TENANT_FORM.CONTRACT_END_DATE' | transloco"
									matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
							</div>
							<div class="date-picker ml--14">
								<app-datepicker [control]="tenantForm.get('contractEndDate')" [placeholder]="'TENANT_FORM.SELECT_CONTRACT_END_DATE' | transloco" class="datepicker" [min]="minDate"></app-datepicker>
								<app-error [control]="tenantForm.get('contractEndDate')"></app-error>
							</div>

						</div>
					</mat-card-content>

				</div>

				<mat-divider class="mb-16 mt-8 neutral-2 mat-divider-dashed"></mat-divider>
				<div class="fw-700 fs-16">{{'TENANT_DETAILS.SETTINGS' | transloco | uppercase}}</div>
				<div class="flex flex-row justify-between">
					<mat-card-content class="pl-0">
						<div class="flex flex-col form-group mat-subtitle-2">
							<div class="flex flex-row">
								<label class="fw-700 fs-12" for="username">{{'TENANT_FORM.ENABLE_START_STOP' | transloco | uppercase}}</label>
							</div>
							<div class="flex flex-row justify-between width-60">
								<div class="flex flex-row items-center fw-500 fs-16">{{'TENANT_LIST.NON_PII_SMALL' | transloco}}<mat-slide-toggle class="ml-8" formControlName="nonpiiEnabled" [checked]="nonpiiEnabledData" (change)="nonpiiEnabled($event)"></mat-slide-toggle></div>
								<div class="flex flex-row items-center fw-500 fs-16">{{'TENANT_LIST.PII' | transloco}}<mat-slide-toggle class="ml-8" formControlName="piiEnabled" [checked]="piiEnabledData" (change)="piiEnabled($event)"></mat-slide-toggle></div>
								<!-- <div class="flex flex-row items-center fw-500 fs-16">{{'TENANT_LIST.PROD' | transloco}}<mat-slide-toggle class="ml-8" formControlName="prodEnabled" [checked]="prodEnabledData" (change)="prodEnabled($event)"></mat-slide-toggle></div> -->
							</div>
						</div>
					</mat-card-content>
					<!-- <mat-card-content>
						<div class="flex flex-col form-group mat-subtitle-2">
							<div class="flex flex-row">
								<label class="fw-700 fs-12" for="username">{{'TENANT_FORM.CHOOSE_PRODUCTION_ENVIRONMENT_CLASS' | transloco | uppercase}}</label>
							</div>
							<div [ngClass]="{'disabled-environment': edit && disableProdDeployment}" class="flex flex-row justify-between width-60 mt-12">
								<div *ngFor="let option of filterOptions" class="flex flex-row items-center cursor-pointer"
								(click)="filterOptionChange(option?.label)" >
									<mat-icon *ngIf="selectedFilter !== option?.label" svgIcon="radio_button_unchecked" class="radio-icon cursor-pointer"></mat-icon>
									<mat-icon *ngIf="selectedFilter === option?.label" svgIcon="radio_button_checked" class="radio-icon cursor-pointer">
									</mat-icon>
								<span class="mat-body-1 fw-500 ml-6 mr-auto mb-0 primary-fg">
									{{option.label}}
								</span>
								</div>
							</div>
						</div>
					</mat-card-content> -->
				</div>
				<mat-card-content>
					<div class="flex flex-col mat-subtitle-2 ml--16">
						<div class="flex flex-row">
							<label class="fw-700 fs-12" for="username">{{'TENANT_LIST.ADD_EMAIL_ADDRESS' | transloco | uppercase}}</label>
							<mat-icon svgIcon="info" class="icon-sm ml-4 mt-4" matTooltipClass="form-tooltip right" [matTooltip]="'TENANT_FORM.ADD_EMAIL_ADDRESS' | transloco"
							matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
						</div>
						<mat-form-field class="email-list">
							<mat-chip-grid #chipGrid aria-label="Email Address">
								<mat-chip-row *ngFor="let email of emails"
								(removed)="remove(email)" [ngClass]="{'invalid-email': !isValidEmail(email)}">
								{{email}}
								<button matChipRemove>
									<mat-icon svgIcon="close"></mat-icon>
								</button>
								</mat-chip-row>
								<input placeholder="{{'TENANT_LIST.EMAIL_ADDRESS' | transloco}}"
									[matChipInputFor]="chipGrid"
									[matChipInputSeparatorKeyCodes]="separatorKeysCodes"
									[matChipInputAddOnBlur]="addOnBlur"
									(matChipInputTokenEnd)="add($event)"
									formControlName="notificationEmails"/>
							</mat-chip-grid>
						</mat-form-field>
						<span *ngIf="emails?.length > limit" class="max-limit mt--24 fs-12">{{'TENANT_FORM.ALLOW_MAX_EMAIL_ADDRESS' | transloco: {limit: limit} }}</span>
						<span *ngIf="invalidEmail && invalidEmail?.length !== 0 && emails?.length <= limit" class="max-limit mt--24 fs-12">{{'TENANT_FORM.ENTER_VALID_EMAIL' | transloco}}</span>
					</div>
				</mat-card-content>
			</mat-card>
			<sat-popover #regionPair verticalAlign="below" forceAlignment hasBackdrop>
			<div class="tooltip-wrapper">
				<div class="default-dialog-wrapper mat-elevation-z10">
					<div class="flex flex-row content">
						<div class="flex flex-col justify-between w-100-percent">
						<div class="flex flex-row w-100-percent">
							<h1 class="flex flex-wrap basis-full mat-headline-5 mb-14 fw-600">{{'ADD_VERSION.TEMENOS_REGION' | transloco }}</h1>
							<mat-icon svgIcon="close" class="flex justify-end cursor-pointer icon-lg" (click)="regionPair.toggle()"></mat-icon>
						</div>
						<div class="flex flex-row mat-subtitle-2 fw-400 mb-24">{{'TENANT_FORM.TEMENOS_REGION_MESSAGE' | transloco }}</div>
						</div>
					</div>
					<div class="flex flex-row mb-14 ml-10">
						<a href="javascript:void(0);" class="link" (click)="openUrl()">{{'TENANT_LIST.GO_TO_DOCUMENTATION' | transloco }}</a>
						<mat-icon class="h-18 w-18 ml-6" svgIcon="open_in_new" (click)="openUrl()"></mat-icon>
					</div>
				</div>
			</div>
			</sat-popover>
			<sat-popover #primaryCloudRegion verticalAlign="below" forceAlignment hasBackdrop>
			<div class="tooltip-wrapper">
				<div class="default-dialog-wrapper mat-elevation-z10">
					<div class="flex flex-row content">
						<div class="flex flex-col justify-between w-100-percent">
						<div class="flex flex-row w-100-percent">
							<h1 class="flex flex-wrap basis-full mat-headline-5 mb-14 fw-600">{{'TENANT_LIST.PRIMARY_REGION' | transloco }}</h1>
							<mat-icon svgIcon="close" class="flex justify-end cursor-pointer icon-lg" (click)="primaryCloudRegion.toggle()"></mat-icon>
						</div>
						<div class="flex flex-row mat-subtitle-2 fw-400 mb-24">{{'TENANT_FORM.PRIMARY_REGION_DESCRIPTION' | transloco }}</div>
						</div>
					</div>
					<div class="flex flex-row mb-14 ml-10">
						<a href="javascript:void(0);" class="link" (click)="openUrl()">{{'TENANT_LIST.GO_TO_DOCUMENTATION' | transloco }}</a>
						<mat-icon class="h-18 w-18 ml-6" svgIcon="open_in_new" (click)="openUrl()"></mat-icon>
					</div>
				</div>
			</div>
			</sat-popover>
			<sat-popover #secondaryCloudRegion verticalAlign="below" forceAlignment hasBackdrop>
			<div class="tooltip-wrapper">
				<div class="default-dialog-wrapper mat-elevation-z10">
					<div class="flex flex-row content">
						<div class="flex flex-col justify-between w-100-percent">
						<div class="flex flex-row w-100-percent">
							<h1 class="flex flex-wrap basis-full mat-headline-5 mb-14 fw-600">{{'TENANT_LIST.SECONDARY_REGION' | transloco }}</h1>
							<mat-icon svgIcon="close" class="flex justify-end cursor-pointer icon-lg" (click)="secondaryCloudRegion.toggle()"></mat-icon>
						</div>
						<div class="flex flex-row mat-subtitle-2 fw-400 mb-24">{{'TENANT_FORM.SECONDARY_REGION_DESCRIPTION' | transloco }}</div>
						</div>
					</div>
					<div class="flex flex-row mb-14 ml-10">
						<a href="javascript:void(0);" class="link" (click)="openUrl()">{{'TENANT_LIST.GO_TO_DOCUMENTATION' | transloco }}</a>
						<mat-icon class="h-18 w-18 ml-6" svgIcon="open_in_new" (click)="openUrl()"></mat-icon>
					</div>
				</div>
			</div>
			</sat-popover>
			<span class="flex-auto"></span>
			<mat-divider class="mb-32 mt-24"></mat-divider>
			<div class="flex flex-row justify-end w-100-percent">
				<button [disabled]="loading" type="cancel" class="white" (click)="cancel()">{{'DIALOG.CANCEL' | transloco}}</button>
				<ng-container *ngIf="invalidEmail">
					<button [disabled]="loading" type="submit" class="accent ml-12" [ngClass]="{'disabled': (invalidEmail && invalidEmail?.length !== 0 || emails.length > limit)}">{{'TENANT_FORM.SUBMIT' | transloco}}</button>
				</ng-container>
			</div>
		</form>
	</ng-container>
	<ng-template #sentMessageResult>
		<div class="flex flex-row justify-between">
			<mat-card-content class="fs-24 fw-700">{{title}}</mat-card-content>
			<mat-icon class="justify-items-end cursor-pointer icon-lg" (click)="sidenavService.closeRightSidenav('data')"  svgIcon="close"></mat-icon>
		</div>
		<mat-divider></mat-divider>
		<span *ngIf="successMessage || editedSuccess" class="overflow-y-auto">
			<div class="flex flex-col justify-center items-center mb-20 ml-20">
			<div class="green-oval mt-150 mb-20">
				<mat-icon svgIcon="done"></mat-icon>
			</div>
			<div class="mat-headline-5 mb-20">{{successMessage? ('TENANT_FORM.TENANT_ADDED' | transloco): ('TENANT_FORM.TENANT_UPDATED' | transloco)}}</div>
			<div class="flex-row" dir="rtl">
				<button type="button" class="white"
				(click)="sidenavService.closeRightSidenav('data')">{{'BUTTONS.CLOSE' | transloco}}</button>
			</div>
			</div>
		</span>
	</ng-template>
	<div class="overlay" *ngIf="isLoading">
		<mat-spinner diameter="24" color="primary" mode="indeterminate"></mat-spinner>
	</div>
</div>
